<template>

  <data-form
    model="owners"
    :entity="model"
    :fields="ownerFields"
    :after-submit="afterSubmit"
    :cancel="false"
  />

</template>

<script>
import ownerFields from 'components/owner/ownerFields'

export default {
  name: 'owner-form',
  data () {
    return {
      model: {
        id: 'new'
      },
      ownerFields
    }
  },
  computed: {},
  methods: {
    afterSubmit () {
      this.$emit('next')
    }
  },
  beforeMount () {}
}
</script>

<style>
</style>


// WEBPACK FOOTER //
// OwnerForm.vue?9e069624